module.exports = __webpack_public_path__ + "img/red_king_crab.327e5476.png";